export default "__VITE_ASSET__JB7ycThD__"